import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { PrevisionService } from '@core/services/prevision.service';
import { IPrevisiones } from '@models/IPrevisiones';
import { PrevisionesTableComponent } from '@shared/previsiones-table/previsiones-table.component';

@Component({
  selector: 'app-ultimas-previsiones',
  imports: [PrevisionesTableComponent],
  providers: [DatePipe],
  templateUrl: './ultimas-previsiones.component.html',
  styleUrl: './ultimas-previsiones.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UltimasPrevisionesComponent {
  ultimasPrevisiones = signal<IPrevisiones>([]);
  centroId = input<number>();
  constructor(private pervisionService: PrevisionService) {
    effect((onCleanup) => {
      const id = this.centroId();
      if (id == null) return;

      const dates = this.pervisionService.calculateWeekRange();
      const sub = this.pervisionService
        .getPrevisionByDates(dates.beginDate, dates.endDate, id)
        .subscribe({
          next: (res) => {

            this.ultimasPrevisiones.set(res)
          },
          error: () => this.ultimasPrevisiones.set([]),
        });

      onCleanup(() => sub.unsubscribe());
    });
  }


  // getPrevisones(centro?: number) {
  //   const dates = this.pervisionService.calculateWeekRange();
  //   console.log('getPrevisones');
  //   this.pervisionService
  //     .getPrevisionByDates(dates.beginDate, dates.endDate, centro || 1)
  //     .subscribe(
  //       {
  //         next: (res: IPrevisiones) => {
  //           this.ultimasPrevisiones.set(res);
  //         },
  //         error: (err: any) => {
  //           this.ultimasPrevisiones.set([]);
  //         },
  //       }
  //     );

  // }


  // getPrevisones(centro?: number) {
  //   const dates = this.pervisionService.calculateWeekRange();

  //   if (centro !== undefined && centro !== null) {
  //     this.pervisionService
  //       .getPrevisionByDates(dates.beginDate, dates.endDate, centro)
  //       .subscribe(
  //         {
  //           next: (res: IPrevisiones) => {
  //             console.log(res);
  //             this.ultimasPrevisiones.set(res);
  //           },
  //           error: (err: any) => {
  //             console.error(err);
  //             this.ultimasPrevisiones.set([]);
  //           },
  //         }
  //       );
  //   } else {
  //     // sin el tercer parámetro → se aplica el default "centro = 1" del servicio
  //     this.pervisionService
  //       .getPrevisionByDates(dates.beginDate, dates.endDate)
  //       .subscribe(
  //         {
  //           next: (res: IPrevisiones) => {
  //             this.ultimasPrevisiones.set(res);
  //           },
  //           error: (err: any) => {
  //             console.error(err);
  //             this.ultimasPrevisiones.set([]);
  //           },
  //         }
  //       );
  //   }
  // }

}
